import moment from "moment";
import React from "react";
import type { IOnelineNoticeList } from "service/interface/notice";

interface Props {
  data: IOnelineNoticeList[];
}

export function OnelineNoticeListTable({ data }: Props) {
  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[816px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              제목
            </th>
            <th
              scope="col"
              className="min-w-[149px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((member) => (
            <tr
              key={member.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {member.id}
              </td>
              <td className="w-[816px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {member.content}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(member.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
